// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Banner {
  width: 100%;
  position: relative;
}

.Banner--regular {
  line-height: 2.42rem;
  padding: 2.18rem 1.42rem;
  font-size: 1.28rem;
}

.Banner--slim {
  padding: 1.1rem;
  font-size: 1.1rem;
}

.Banner--primary {
  color: var(--palette-thribee-white);
  background: var(--palette-trovit-blue);
}

.Banner--warning {
  color: var(--palette-text);
  background: var(--palette-thribee-yellow);
}

.Banner--error {
  color: var(--palette-thribee-white);
  background: var(--palette-thribee-red);
}

.Banner--success {
  color: #3C763D;
  background-color: #DFF0D8;
  border: 1px solid #D6E9C6;
  border-radius: 4px;
}

.ClosableBanner {
    padding-right: 3rem;
}

.ClosableBanner__close {
  background: transparent;
  border: none;
  position: absolute;
  right: 1rem;
  top: 1rem;
  cursor: pointer;
  padding: 0;
}

.Banner--success .ClosableBanner__close {
  color: rgba(0, 0, 0, 0.15);
}

.Banner--legacy {
  position: relative;
  text-align: left;
  border-radius: 4px;
  color: #31708f;
  background-color: #d9edf7;
  border-color: #bce8f1;
}

.Banner--legacy.Banner--warning {
  background-color: var(--palette-warning-background);
  color: var(--palette-text);
}

.Banner--legacy a {
  color: #245269;
  font-weight: 700;
  text-decoration: none;
}

.CampaignForm__wrapper .UpdatedTrackingParametersBanner {
  margin-left: -20px;
  width: calc(100% + 40px);
}

.CampaignForm__wrapper .UpdatedTrackingParametersBanner:first-child {
  margin-top: -20px;
}

.UpdatedTrackingParametersBanner > span{
  padding-right: 1.42rem;
}

.UpdatedTrackingParametersBanner {
  display: flex;
}

.UpdatedTrackingParametersBanner .Banner-button {
  color: var(--palette-trovit-blue);
  background-color: var(--palette-whipe);
  padding: 0 1.5rem;
}

.UpdatedTrackingParametersBanner .ClosableBanner__close {
  flex-grow: 1;
  text-align: right;
  position: static;
  line-height: initial;
}
`, "",{"version":3,"sources":["webpack://./js/components/library/html/Banner/Banner.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mDAAmD;EACnD,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;AACtB","sourcesContent":[".Banner {\n  width: 100%;\n  position: relative;\n}\n\n.Banner--regular {\n  line-height: 2.42rem;\n  padding: 2.18rem 1.42rem;\n  font-size: 1.28rem;\n}\n\n.Banner--slim {\n  padding: 1.1rem;\n  font-size: 1.1rem;\n}\n\n.Banner--primary {\n  color: var(--palette-thribee-white);\n  background: var(--palette-trovit-blue);\n}\n\n.Banner--warning {\n  color: var(--palette-text);\n  background: var(--palette-thribee-yellow);\n}\n\n.Banner--error {\n  color: var(--palette-thribee-white);\n  background: var(--palette-thribee-red);\n}\n\n.Banner--success {\n  color: #3C763D;\n  background-color: #DFF0D8;\n  border: 1px solid #D6E9C6;\n  border-radius: 4px;\n}\n\n.ClosableBanner {\n    padding-right: 3rem;\n}\n\n.ClosableBanner__close {\n  background: transparent;\n  border: none;\n  position: absolute;\n  right: 1rem;\n  top: 1rem;\n  cursor: pointer;\n  padding: 0;\n}\n\n.Banner--success .ClosableBanner__close {\n  color: rgba(0, 0, 0, 0.15);\n}\n\n.Banner--legacy {\n  position: relative;\n  text-align: left;\n  border-radius: 4px;\n  color: #31708f;\n  background-color: #d9edf7;\n  border-color: #bce8f1;\n}\n\n.Banner--legacy.Banner--warning {\n  background-color: var(--palette-warning-background);\n  color: var(--palette-text);\n}\n\n.Banner--legacy a {\n  color: #245269;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.CampaignForm__wrapper .UpdatedTrackingParametersBanner {\n  margin-left: -20px;\n  width: calc(100% + 40px);\n}\n\n.CampaignForm__wrapper .UpdatedTrackingParametersBanner:first-child {\n  margin-top: -20px;\n}\n\n.UpdatedTrackingParametersBanner > span{\n  padding-right: 1.42rem;\n}\n\n.UpdatedTrackingParametersBanner {\n  display: flex;\n}\n\n.UpdatedTrackingParametersBanner .Banner-button {\n  color: var(--palette-trovit-blue);\n  background-color: var(--palette-whipe);\n  padding: 0 1.5rem;\n}\n\n.UpdatedTrackingParametersBanner .ClosableBanner__close {\n  flex-grow: 1;\n  text-align: right;\n  position: static;\n  line-height: initial;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
